<mat-toolbar class="ap-border-bottom ap-border-gray mat-toolbar mat-toolbar-single-row">
  <ng-content select=".ap-menu-mobile"></ng-content>
  <ng-content select=".ap-brand-image"></ng-content>
  <ng-content></ng-content>
</mat-toolbar>